import axios from 'axios';
import type { StudioJobPreferenceDisplayModel } from '@shared/models/jobs/jobPreferences';
import type { identifier } from '@core/models/base';
import { axiosToServiceResult } from '@shared/axios';
import type { ServiceSuccess } from '@core/models/actionResponse';

export const getJobPreferences = async (
  studioId: identifier,
  jobId: identifier,
): Promise<ServiceSuccess<StudioJobPreferenceDisplayModel>> => {
  // this server request should always succeed
  const data = (
    await axios.get<StudioJobPreferenceDisplayModel>(`/api/customer/studios/${studioId}/jobs/${jobId}/job-preferences`)
  ).data;
  return { data };
};
